// eslint-disable-next-line @trello/export-matches-filename
import { Noun, Verb, trackUe } from '@trello/analytics';
import { Analytics } from '@trello/atlassian-analytics';

interface AtlassianOnboardingAnalyticsParams {
  verb: Verb;
  noun: Noun;
  method: string;
  context?: object;
  actionSubject: string;
  action: string;
  actionSubjectId: string;
  source: string;
}

export const track = ({
  verb,
  noun,
  method,
  context,
  actionSubject,
  actionSubjectId,
  action,
  source,
}: AtlassianOnboardingAnalyticsParams) => {
  //Send Snowplow Analytics
  trackUe({
    category: Noun.ATLASSIAN_ACCOUNT_ONBOARDING,
    verb: verb,
    directObj: noun,
    method: method,
    context: JSON.stringify(context),
  });

  //Send Atlassian Analytics
  Analytics.sendTrackEvent({
    action,
    actionSubject,
    actionSubjectId,
    source,
    attributes: context,
  });
};
